/**
 * @generated SignedSource<<36b69ca2bb7a8ea08aa0d3adb3ac229b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDetail_memberPackage$data = {
  readonly id: string;
  readonly package: {
    readonly " $fragmentSpreads": FragmentRefs<"PackageBenefitsSummary_package">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"PackageDetailActions_memberPackage" | "PackageDetailBilling_memberPackage">;
  readonly " $fragmentType": "PackageDetail_memberPackage";
};
export type PackageDetail_memberPackage$key = {
  readonly " $data"?: PackageDetail_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDetail_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDetail_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDetailActions_memberPackage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDetailBilling_memberPackage"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PackageBenefitsSummary_package"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "21a1eb5f059de0a248bb8734c55e1331";

export default node;
